document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.variant-selector').forEach(function (selectEl) {
    selectEl.addEventListener('change', function () {
      const variantId = this.value;
      const stockData = this.querySelector(`option[value="${variantId}"]`);
      const stockQty = stockData ? stockData.getAttribute('data-stock') : null;
      const productId = this.getAttribute('data-product-id');

      if (stockQty !== null && productId) {
        const inventoryBlock = document.getElementById(`inventory-${productId}`);
        if (inventoryBlock) {
          let level = 'normal';
          const qty = parseInt(stockQty, 10);
          if (qty <= 0) {
            level = 'hide';
            inventoryBlock.innerText = 'Out of stock';
          } else if (qty <= 5) {
            level = 'Very low stock (' + qty + ' available)';
            inventoryBlock.innerText = level;
          } else if (qty <= 10) {
            level = 'Low stock (' + qty + ' available)';
            inventoryBlock.innerText = level;
          } else {
            level = 'In stock (' + qty + ' available)';
            inventoryBlock.innerText = level;
          }
        }
      }
    });
  });
});